<template>
  <div class="comfortable-credit-info">
    <h2 class="title fn-title-1">Кредитна лінія «Зручна»</h2>

    <p class="m-body-m description">
      Потребує мінімум документів.
      <br>
      Прийняття рішення за 2 години.
      <br>
      Оформлення траншів у клієнт-банку без відвідування відділення.
      <br>
      Від 25% річних.
    </p>

    <ul class="tabs">
      <li class="item m-body-sb" :class="{ active: typeLocal === 'flp' }" v-on:click="checkType('flp')">Підприємець</li>
      <li class="item m-body-sb" :class="{ active: typeLocal === 'jur' }" v-on:click="checkType('jur')">Юридична особа</li>
    </ul>

    <div v-if="typeLocal === 'flp'" class="tab-content tab-content-flp">
      <h4 class="content-title m-body-sb">Умови:</h4>

      <div class="row">
        <div class="column row-title m-body-m">Ліміт кредитної лінії</div>
        <div class="column row-value m-body-b">до 500 000 грн</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Комісія за встановлення</div>
        <div class="column row-value m-body-b">1% (разово)</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Комісія за видачу траншу</div>
        <div class="column row-value m-body-b">від 1,25% до 2%</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Строки траншів</div>
        <div class="column row-value m-body-b">30, 60, 90, 180 днів</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Погашення</div>
        <div class="column row-value m-body-b">
          Безготівкове перерахування коштів на свій поточний рахунок, або на рахунок для погашення кредиту, визначений
          умовами договору
        </div>
      </div>

      <div class="annual-rate-block">
        <div class="row-title m-body-m w100">Річна % ставка в залежності від строку траншу:</div>
        <div class="annual-rate">
          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">30 днів</div>
            <div class="annual-rate-value m-body-b">25%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">60 днів</div>
            <div class="annual-rate-value m-body-b">27%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">90 днів</div>
            <div class="annual-rate-value m-body-b">30%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">180 днів</div>
            <div class="annual-rate-value m-body-b">33%</div>
          </div>
        </div>
      </div>

      <h4 class="content-title m-body-sb">Документи для заявки:</h4>

      <div class="row">
        <div class="column row-title m-body-m w100">
          декларація про доходи за останній звітній період (не менш ніж за півроку)
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          виписка за рахунками ФОП свого банку з детальним розшифруванням рухів коштів за останні 12 міс.
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          фото бізнесу (місце розташування торгової точки, асортимент товару, офіс і т.п.)
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          ОСВ по рахунках 28, 36, 63, 68, 70 за останні 12 місяців
        </div>
      </div>
    </div>

    <div v-if="typeLocal === 'jur'" class="tab-content tab-content-flp">
      <h4 class="content-title m-body-sb">Умови:</h4>

      <div class="row">
        <div class="column row-title m-body-m">Ліміт кредитної лінії</div>
        <div class="column row-value m-body-b">до 2 000 000 грн</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Комісія за встановлення</div>
        <div class="column row-value m-body-b">1% (разово)</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Комісія за видачу траншу</div>
        <div class="column row-value m-body-b">від 1,25% до 2%</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Строки траншів</div>
        <div class="column row-value m-body-b">30, 60, 90, 180 днів</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Погашення</div>
        <div class="column row-value m-body-b">
          Безготівкове перерахування коштів на свій поточний рахунок, або на рахунок для погашення кредиту, визначений
          умовами договору
        </div>
      </div>

      <div class="annual-rate-block">
        <div class="row-title m-body-m w100">Річна % ставка в залежності від строку траншу:</div>
        <div class="annual-rate">
          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">30 днів</div>
            <div class="annual-rate-value m-body-b">25%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">60 днів</div>
            <div class="annual-rate-value m-body-b">27%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">90 днів</div>
            <div class="annual-rate-value m-body-b">30%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">180 днів</div>
            <div class="annual-rate-value m-body-b">33%</div>
          </div>
        </div>
      </div>

      <h4 class="content-title m-body-sb">Документи для заявки:</h4>

      <div class="row">
        <div class="column row-title m-body-m w100">
          фінансова звітність за останній звітний рік
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          виписка за рахунками свого банку з детальним розшифруванням рухів коштів за останні 12 міс.
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          фото бізнесу (місце розташування торгової точки, асортимент товару, офіс і т.д.)
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          ОСВ по рахунках 28, 36, 63, 68, 70 за останні 12 місяців
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: 'flp'
    }
  },
  data: function () {
    return {
      typeLocal: ''
    }
  },
  methods: {
    checkType: function (type) {
      this.typeLocal = type
      this.$emit('update:type', type)
    }
  },
  watch: {
    type: {
      immediate: true,
      handler (val) {
        this.typeLocal = val
      }
    }
  }
}

</script>

<style scoped lang="less">
.comfortable-credit-info {
  text-align: left;

  .title {
    margin: 0 0 16px 0;
    color: var(--black);
  }

  .description {
    margin: 0 0 36px 0;
    color: var(--black);
  }

  .tab-content {
    margin: 42px 0 0 0;

    .content-title {
      margin: 0 0 8px 0;
      color: var(--grey-140)
    }

    .row {
      display: flex;
      align-items: center;
      padding: 12px 0;
      border-top: 1px solid var(--grey-240);

      .column {
        width: 50%;
      }

      .row-title {
        position: relative;
        padding: 0 0 0 24px;
        color: var(--black);

        &:before {
          content: '';
          position: absolute;
          top: 7px;
          left: 8px;
          width: 8px;
          height: 8px;
          border-radius: 100%;
          background: var(--second-base);
        }
      }

      .row-value {
        display: flex;
        color: var(--black);

        .third {
          width: 33%;
        }
      }
    }

    .row + .content-title {
      margin: 52px 0 8px 0;
    }

    .annual-rate-block {
      display: flex;
      flex-direction: column;
      padding: 12px 0;
      border-top: 1px solid var(--grey-240);

      .row-title {
        position: relative;
        padding: 0 0 0 24px;
        &:before {
          content: '';
          position: absolute;
          top: 7px;
          left: 8px;
          width: 8px;
          height: 8px;
          border-radius: 100%;
          background: var(--second-base);
        }
      }

      .annual-rate {
        margin: 15px 0;
        padding: 0 0 0 24px;
      }

      .annual-rate-row {
        display: flex;
        margin: 0 0 5px 0;

        .annual-rate-title {
          width: 30%;
        }
      }
    }
  }
}
</style>
